module.exports = __webpack_public_path__ + "static/media/digital.14b230eb.jpg";